import { SidefiResponse, ConsultaSidefiResponse } from "@interfaces/sidefi/sidefi.interface";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

const URL_BACKEND = environment.urlBackend;

@Injectable({
  providedIn: 'root'
})
export class SidefiAfiliadosService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  async consultarAfiliacionSidefi(identificacion: string): Promise<SidefiResponse | null> {

    try {

      if (!identificacion || identificacion.trim() === '') {
        console.warn('SidefiAfiliadosService: La identificación proporcionada está vacía.');
        return null;
      }

      const body = {
        dni: identificacion
      };

      const resp = await this.httpClient.post<ConsultaSidefiResponse>(`${URL_BACKEND}/signo-sidefi/consulta`, body).toPromise();

      if (!resp) {
          console.warn('SidefiAfiliadosService: La respuesta de la API fue vacía o nula.');
          return null;
      }

      return resp.response;

    } catch (error) {

      console.error('Error al consultar la afiliación en Sidefi:', error);

      return null;
    }
  }

}